import { Component, Injectable, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from 'src/app/shared/services/auth.service';
import { ApiService } from '../../../shared/services/api.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { DatosDenuncia } from 'src/app/shared/models/datosDenuncia';
import { Apelaciones } from '../../../model/datosApelaciones';
import { Testigo } from 'src/app/ver-denuncias/models/testigo';
import { Documento } from 'src/app/ver-denuncias/models/documento';
import { Comentario } from 'src/app/ver-denuncias/models/comentario';
import { Usuarios } from 'src/app/ver-denuncias/models/usuarios';
import { DatePipe } from '@angular/common';
import { FormControl, FormGroup } from '@angular/forms';
import { environment } from 'src/environments/environment.prod';
import { HttpClient } from '@angular/common/http';
import { VerDenunciaService } from 'src/app/ver-denuncias/services/ver-denuncia.service';
import { SpinnerService } from 'src/app/services/spinner.service';
import { PeertopeerService } from 'src/app/shared/services/peertopeer.service';
import * as CryptoJS from 'crypto-js';
import { Response } from 'src/app/shared/models/response.model';
import { SafeResourceUrl } from '@angular/platform-browser';
import { FileUtilsService } from 'src/app/shared/services/file-utils.service';

@Injectable()
@Component({
  selector: 'app-ver-denuncia',
  templateUrl: './ver-denuncia.component.html',
  styleUrls: ['./ver-denuncia.component.css'],
  providers: [DatePipe],
})
export class VerDenunciaComponent implements OnInit {
  basePath = environment.baseUrl; // O cualquier variable que tengas en environment.ts
  validatingForm: FormGroup;
  audioBlobUrl2: any; //audio recorder
  audioBlob: any; //audio recorder
  audioName = ''; //audio recorder
  isAudioRecording = false; //boton de stop
  audioRecordedTime = ''; //audio time
  pin_code: string;
  denuncia: DatosDenuncia[];
  apelaciones: Apelaciones;
  testigo: Testigo[];
  documento: Documento[];
  bExisteTestigo = true;
  bExisteDocumento = true;
  id: string;
  comentarios: Comentario[];
  avatar: string;
  showChat: boolean = false;
  show: boolean = true;
  showReopen: boolean = false;
  progressBar: number = 0;
  backgroundColor: string = 'red';
  ipAddress = '';
  sendChat: boolean = false;
  usuario_denuncia: Usuarios[];
  archivo: Documento[];
  showCenter: boolean = false;
  isActiveIdPersonalizable: boolean = false; //Is Active Id Custom
  PHP_API_SERVER = environment.baseUrl;//"http://127.0.0.1:8080";
  url: SafeResourceUrl | null = null;
  showFile = false;
  mimeType: string | null = null;
  showPreviewInfo = true;

  constructor(
    private verDenunciaService: VerDenunciaService,
    private router: Router,
    private auth: AuthService,
    private apiService: ApiService,
    private toastr: ToastrService,
    private translate: TranslateService,
    private actRoute: ActivatedRoute,
    private datepipe: DatePipe,
    private http: HttpClient,
    private spinnerSvc: SpinnerService,
    private cryptoService: PeertopeerService,
    private fileUtilsService: FileUtilsService
  ) { }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    let language = this.auth.getLanguage();
    if (language == '' || language == null) {
      language = 'es';
    }
    this.id = this.actRoute.snapshot.params.id;

    this.validatingForm = new FormGroup({
      comentarioDenuncia: new FormControl(''),
    });
    //check if customizable id is active
    let isActiveIsPersonalizable = '0';
    if (this.auth.getIdPersonalizable() == '1') {
      isActiveIsPersonalizable = '1';
      this.isActiveIdPersonalizable = true;
    } else {
      this.isActiveIdPersonalizable = false;
    }
    //check if centers is active
    let isActiveCenter = '0';
    if (this.auth.getCentros() == '1') {
      isActiveCenter = '1';
      this.showCenter = true;
    }

    this.avatar = environment.baseAvatar + 'social.png';
    this.translate.setDefaultLang(language);
    this.pin_code = this.actRoute.snapshot.params.id;
    this.verDenunciaService
      .searchComplaintById(
        this.pin_code,
        language,
        this.auth.getIdUser(),
        isActiveCenter,
        isActiveIsPersonalizable,
        'denunciante'
      )
      .subscribe({
        next: (denuncia) => {
          if (denuncia.code === 200 && denuncia.success) {
            this.denuncia = denuncia.data;
            this.handleDenunciaData(denuncia);
          }
        }, error: (error) => {
          this.denuncia = [];
        }
      });
  }

  handleDenunciaData(denuncia) {
    // Get all the appeals for the complaint
    this.loadAppeals(this.denuncia[0].id_denuncia, this.denuncia[0].id_fase);

    // format date
    const endComplianceDate = this.denuncia[0].fin_plazo_compliance;
    const dateObj = new Date(endComplianceDate);
    const currentLang = this.translate.currentLang;

    const formattedDate = dateObj.toLocaleDateString(currentLang, {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });

    if (denuncia.length == 0) {
      // this.getIPAddress();
      // console.log('No se encontraron denuncias');
      this.toastr.error(
        this.translate.instant('texto_189'),
        this.translate.instant('texto_190')
      );
      this.router
        .navigateByUrl('/RefreshComponent', { skipLocationChange: true })
        .then(() => {
          this.router.navigate(['/ver-denuncia/', this.id]);
        });
    } else {
      let indice = localStorage.getItem('verdenuncia');
      if (indice == '0') {
        this.router.navigate(['/ver-denuncia/consultar-denuncia']);
      } else {
        localStorage.setItem('verdenuncia', '1');
      }
      if (this.denuncia[0].id_fase == '0') {
        this.progressBar = 12;
        this.sendChat = true;
      } else if (this.denuncia[0].id_fase == '1') {
        this.progressBar = 24;
        this.showChat = true;
        this.backgroundColor = 'red';
        this.sendChat = true;
      } else if (this.denuncia[0].id_fase == '11') {
        this.progressBar = 24;
        this.showChat = true;
        this.backgroundColor = 'red';
        this.sendChat = true;
      } else if (this.denuncia[0].id_fase == '2') {
        this.progressBar = 36;
        this.showChat = true;
        this.backgroundColor = '#F1C453';
        this.sendChat = true;
      } else if (this.denuncia[0].id_fase == '3') {
        this.showChat = true;
        this.progressBar = 48;
        this.backgroundColor = '#EFEA5A';
        this.sendChat = true;
      } else if (this.denuncia[0].id_fase == '4') {
        this.progressBar = 60;
        this.backgroundColor = '#B9E769';
        this.show = false;
      } else if (this.denuncia[0].id_fase == '5') {
        this.progressBar = 74;
        this.backgroundColor = '#83E377';
        this.show = false;
        this.toastr.info(`${this.translate.instant('texto_923')} ${formattedDate}; ${this.translate.instant('texto_924')}`, this.translate.instant('texto_27'));
      } else if (this.denuncia[0].id_fase == '6') {
        this.progressBar = 100;
        this.backgroundColor = '#16DB93';
        this.show = false;
      } else if (this.denuncia[0].id_fase == '8') {
        this.progressBar = 100;
        this.backgroundColor = '#16DB93';
        this.show = false;
      } else if (this.denuncia[0].id_fase == '7') {
        this.progressBar = 100;
        this.backgroundColor = '#16DB93';
        this.show = false;
      } else if (this.denuncia[0].id_fase == '12') {
        this.progressBar = 100;
        this.backgroundColor = '#a6a5a5';
        this.sendChat = true;
      }

      let denunciante = this.denuncia[0].denunciante_correo;
      if (denunciante == '') {
        denunciante = 'Denunciante';
      }
      this.verDenunciaService
        .searchWitnessByUserComplaint(
          this.denuncia[0].id_denuncia,
          denunciante
        )
        .subscribe({
          next: (response: Response<Testigo[]>) => {
            if (response.code === 200 && response.success) {
              this.bExisteTestigo = true;
              this.testigo = response.data;
            } else {
              this.bExisteTestigo = false;
            }
          }, error: (error) => {
            if (error.status !== 404) {
              this.toastr.error(
                this.translate.instant('texto_890'),
                this.translate.instant('texto_813')
              );
            }
            this.bExisteTestigo = false;
          }
        });

      this.verDenunciaService.searchDocumentsByUserComplaint(this.denuncia[0].id_denuncia, denunciante)
        .subscribe({
          next: (res) => {
            this.documento = res.data ?? [];
            if (res.code === 200 && res.success) {
              this.bExisteDocumento = true;
            }
          },
          error: (err) => {
            if (err.error.code === 404 && !err.error.success) {
              this.bExisteDocumento = false;
            } else {
              this.toastr.error(this.translate.instant('texto_890'), this.translate.instant('texto_813'));
            }
          }
        });
    }

    this.verDenunciaService
      .searchCommentsByComplaint(this.denuncia[0].id_denuncia, false, 'denunciante')
      .subscribe((response: Response<Comentario[]>) => {
        this.comentarios = response.data || [];
        this.showChat = this.comentarios.length > 0;
      });



  }

  /**
* Method for navigating to "boton1" after navigating to a section "services".
*/
  navigateToButton() {
    // Navigate to the 'services' section first
    // this.navigationService.navigateToSection('services');
    const element = document.getElementById('mainContent');

    setTimeout(() => {
      // After a delay, invoke the navigateToButton method of the NavigationService to focus the button.
      if (element) {
        element.focus();
      }
    }, 500); // Wait for a specified time to ensure the navigation is complete before focusing the button.
  }

  get comentarioDenuncia() {
    return this.validatingForm.get('comentarioDenuncia');
  }


  /**
  * Function to send a comment and notifies all related users via email.
  *
  * @param {number} id_denuncia - The ID of the complaint.
  */
  enviarMensaje(id_denuncia) {
    // Get the current date and time, formatted as 'yyyy-MM-dd HH:mm:ss'.
    let date = new Date();
    let _date = this.datepipe.transform(date, 'yyyy-MM-dd HH:mm:ss');

    // Determine the name to use in the message, either the complainant's name or user ID.
    let nombre = this.denuncia[0].denunciante_nombre != '' ? this.denuncia[0].denunciante_nombre : this.denuncia[0].id_usuario;

    // Get the comment from the complaint, stripping any HTML tags.
    let comentario = this.comentarioDenuncia.value.replace(/<[^>]*>/g, '');

    if (comentario) {
      // Replace any single quotes in the comment to prevent SQL injection.
      comentario = comentario.replace(/'/g, '');

      // Check if the complaint exists and the complaint ID is valid.
      if (this.denuncia && this.denuncia.length > 0 && id_denuncia) {
        //encrypt data
        const encryIdSociedad = this.cryptoService.encryptData(this.denuncia[0].id_sociedad);
        const encryIdDenuncia = this.cryptoService.encryptData(id_denuncia.toString());
        const encrytNombre = this.cryptoService.encryptData(nombre);
        const encryComentario = this.cryptoService.encryptData(comentario);
        const encryDate = this.cryptoService.encryptData(_date);
        const encryIdUsuarioIdentificador = this.cryptoService.encryptData('Denunciante');

        // Send a message to the chat service associated with the complaint.
        this.verDenunciaService.sendMessageChat(encryIdSociedad, encryIdDenuncia, encrytNombre, encryComentario, encryDate, encryIdUsuarioIdentificador, false)
          .subscribe((res) => {
            if (res == 200) {
              // Retrieve the list of users related to the complaint.
              this.verDenunciaService.buscarUsuarioDenuncia(id_denuncia, false)
                .subscribe((usuarios: Usuarios[]) => {
                  this.usuario_denuncia = usuarios;
                  if (usuarios.length > 0) {
                    // Check if email clauses are enabled in local storage.
                    let $clau = localStorage.getItem('clausulas_correo') == '1';
                    // Construct the URL for editing the complaint.
                    let url = environment.base + '/editar-denuncia/' + this.denuncia[0].id_denuncia;
                    //let url = 'http://localhost:4200/editar-denuncia/' + this.denuncia[0].id_denuncia;

                    // Loop through each user and send an email notification.
                    usuarios.forEach(usuario => {
                      let idDenunciaMostrado; // Variable to store the complaint ID to be displayed
                      // Check if isActiveIdPersonalizable is true
                      if (this.isActiveIdPersonalizable) {
                        // If true, use identificador_denuncia if it exists, otherwise use id_denuncia
                        idDenunciaMostrado = this.denuncia[0].identificador_denuncia
                          ? this.denuncia[0].identificador_denuncia
                          : this.denuncia[0].id_denuncia;
                      } else {
                        // If isActiveIdPersonalizable is false, only use id_denuncia
                        idDenunciaMostrado = this.denuncia[0].id_denuncia;
                      }
                      let message = `${this.translate.instant('texto_576')} ${usuario.n_user} ${usuario.ape_user}${this.translate.instant('texto_652')} ${idDenunciaMostrado}${this.translate.instant('texto_653')}`;
                      this.verDenunciaService.sendEmail(
                        usuario.mail_user,
                        `${this.translate.instant('texto_654')} ${idDenunciaMostrado}`,
                        message,
                        url,
                        $clau,
                        this.translate.instant('texto_654'),
                        'dashboard-complaint'
                      ).subscribe((emailRes) => {
                        if (emailRes != 200) {
                          this.toastr.error(this.translate.instant('texto_193'), this.translate.instant('texto_195'));
                        }
                      });
                    });

                    // Show a success notification and clear the local storage entry for 'verdenuncia'.
                    this.toastr.success(this.translate.instant('texto_363'), this.translate.instant('texto_364'));
                    localStorage.setItem('verdenuncia', '');
                  }
                });
            } else {
              // Show an error notification if the chat message could not be sent.
              this.toastr.error('texto_29', 'texto_364');
            }
            // Refresh the component and navigate to the complaint view.
            this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true })
              .then(() => {
                this.router.navigate(['ver-denuncia/', this.id]);
              });
          });
      }
    } else {
      // Show an error notification if the comment is empty.
      this.toastr.error(this.translate.instant('texto_481'), this.translate.instant('texto_484'));
    }
  }

  getIPAddress() {
    this.http.get('http://api.ipify.org/?format=json').subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }

  logout() {
    this.auth.logoutSimpleComplaint();
    setTimeout(() => {
      window.location.reload();
    }, 500);
  }

  /**
   * Checks if document preview is enabled in settings.
   * @returns boolean indicating if document preview is enabled.
  */
  isDocumentPreviewEnabled(): boolean {
    const documentPreview = this.auth.getDocumentPreview();
    return documentPreview === '1';
  }

  /**
   * Checks if the MIME type is previewable in the UI.
   * @param tipo_archivo The MIME type of the file.
   * @returns boolean indicating if the file type is previewable.
   */
  isVisualizable(tipo_archivo: string): boolean {
    return this.fileUtilsService.isVisualizable(tipo_archivo);
  }

  /**
   * Closes the preview information message.
  */
  closePreviewInfo(): void {
    this.showPreviewInfo = false;
  }

  /**
   * Downloads a file by its ID, name, and type.
   */
  downloadFile(id_archivo: number) {
    this.fileUtilsService.downloadFile(id_archivo, 'denunciante');
  }

  /**
   * Displays a supported file type in an iframe viewer.
   */
  viewFile(id_archivo: number, tipo_archivo: string, n_archivo: string) {
    this.fileUtilsService.viewFile(id_archivo, tipo_archivo, n_archivo, 'denunciante', (url, mimeType) => {
      this.url = url;
      this.mimeType = mimeType;
      this.showFile = true;
    });
  }


  /**
  * Retrieves appeals and updates the 'showReopen' flag
  * based on the complaint phase and appeal status.
  */
  loadAppeals(complaintId, phaseId) {
    this.apiService.getAppealsByComplaint(complaintId, 'denunciante').subscribe({
      next: (response: Apelaciones) => {
        const permitir_reapertura = response.permitir_reapertura;
        this.apelaciones = response;
        if (permitir_reapertura == 1 && (phaseId == '6' || phaseId == '8')) {
          this.showReopen = true;
        } else {
          this.showReopen = false;
        }
      },
      error: (err) => {
      }
    });
  }
}
